<template>
  <div id="WiseDoctor"> 
    <div class="container-fluid container_fluid">
        <div class="row">
            <!-- <div class="col-md-12 palm_top_nav">
                <img :src="webPalm" class="palm_image">
            </div> -->
            <div class="col-md-12 palm_top_image" v-if="slientWidth > 750">
                <img :src="imgs.webImage" class="palm_image_img" v-for="(imgs,key) in webList" :key="key">
            </div>

            <div class="col-md-12 palm_top_image" v-if="slientWidth < 750">
                <img :src="imgs.appImage" class="palm_image_img" v-for="(imgs,key) in appList" :key="key">
            </div>
        </div>
    </div>
  </div>
</template>

<script>

export default {
  data(){
    return{
        slientWidth:document.body.clientWidth,
        webList:[
            {webImage:'../../../static/image/ProductsImage/KnowGrassImage/webKnowGrass1.png',},
            {webImage:'../../../static/image/ProductsImage/KnowGrassImage/webKnowGrass2.png',},
            {webImage:'../../../static/image/ProductsImage/KnowGrassImage/webKnowGrass3.png',},
            {webImage:'../../../static/image/ProductsImage/KnowGrassImage/webKnowGrass4.png',},
        ],
        appList:[
            {appImage:'../../../static/image/ProductsImage/KnowGrassImage/appKnowGrass1.png',},
            {appImage:'../../../static/image/ProductsImage/KnowGrassImage/appKnowGrass2.png',},
            {appImage:'../../../static/image/ProductsImage/KnowGrassImage/appKnowGrass3.png',},
            {webImage:'../../../static/image/ProductsImage/KnowGrassImage/appKnowGrass4.png',},
        ],

    }
  },
  created(){
      this.slientWidth = document.body.clientWidth
    if(document.body.clientWidth > 750){
      this.webPalm = '../../static/image/ProductsImage/webKnowGrass.png'
      this.webList
    }else{
      this.webPalm = '../../static/image/ProductsImage/appKnowGrass.png'
      this.appList
    }
  },
  methods:{
    
  },
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media screen and (min-width: 750px){
    .palm_image{
        width: 100%;
        min-height: 150px;
    }
    /* .palm_top_image{

    } */
    .palm_image_img{
        width: 100%;
    }
}

/* 移动端特殊样式 */
@media screen and (max-width: 750px){
    .palm_image{
        width: 20%;
    }
    .palm_image_img{
        width: 100%;
    }
}

</style>



// WEBPACK FOOTER //
// src/components/Products/KnowGrass.vue